import { ColumnInstance } from "react-table";
import { NumberField } from "../../form/fields";
import { GraphQLTableColumn } from "../../GraphQL";
import { useDebouncedFilter } from "./utils";

export function NumberColumnTemplate<T extends object = {}>(params?: GraphQLTableColumn<T>): GraphQLTableColumn<T> {
  return {
    Header: "",
    Filter: ({ column: { filterValue, setFilter } }: { column: ColumnInstance }) => {
      const [ value, onChange ] = useDebouncedFilter(filterValue, setFilter);

      return (
        <NumberField
          placeholder="Find..."
          value={value}
          onChange={onChange}
          disabled={params?.filterInputDisabled}
        />
      );
    },
    ...params,
    excelProps: {
      totalsRowFunction: "sum",
      filterButton: true,
      ...params?.excelProps,
    },
  };
}

export default NumberColumnTemplate;
